import React from "react";
const MERCADO_PAGO_LOGO = "https://cdn.magicpatterns.com/uploads/kjKLMDtwEpEKvvM1s6TrSF/Captura_de_pantalla_2026-10-07_a_las_15.14.53.png";
function Badge({
  label,
  children
}: {
  label: string;
  children: React.ReactNode;
}) {
  return <li className="flex h-9 w-14 items-center justify-center rounded-md border border-cream-dark bg-white px-1.5" aria-label={label} title={label} data-id="element-148" data-mp="7d8i3c8e53lu">
      {children}
    </li>;
}
function Circles({
  left,
  right,
  overlap
}: {
  left: string;
  right: string;
  overlap: string;
}) {
  return <svg viewBox="0 0 38 24" className="h-6 w-9" aria-hidden="true" data-id="element-149" data-mp="35xqjh7nej5um">
      <circle cx="13" cy="12" r="10" fill={left} data-id="element-150" data-mp="3ktobcdqalo11" />
      <circle cx="25" cy="12" r="10" fill={right} data-id="element-151" data-mp="3fttl8cecd2h1" />
      <path d="M19 4a10 10 0 0 1 0 16a10 10 0 0 1 0-16z" fill={overlap} data-id="element-152" data-mp="3ft0hzlelcv3n" />
    </svg>;
}
export function PaymentLogos() {
  return <div className="mt-3 flex flex-col items-center gap-4" data-id="element-153" data-mp="104ih5p6mj4q2">
      <img src={MERCADO_PAGO_LOGO} alt="Mercado Pago" className="h-10 w-auto object-contain" data-id="element-154" data-mp="v2t300o3uaxr" />
      <ul className="flex max-w-md flex-wrap items-center justify-center gap-2" data-id="element-155" data-mp="3v2vbaigf50yr">
        <Badge label="Visa" data-id="element-156" data-mp="3wkgh4204wfv">
          <span className="text-[15px] font-black italic tracking-tight text-[#1A1F71]" data-id="element-157" data-mp="3vslnvg8b2qn">VISA</span>
        </Badge>
        <Badge label="Mastercard" data-id="element-158" data-mp="8uc8rz6k6kkl">
          <Circles left="#EB001B" right="#F79E1B" overlap="#FF5F00" data-id="element-159" data-mp="cxs66xqgcoyc" />
        </Badge>
        <Badge label="Maestro" data-id="element-160" data-mp="3cd5ke6fs0zc4">
          <Circles left="#EB001B" right="#00A2E5" overlap="#7375CF" data-id="element-161" data-mp="3cdyk4ngbiokr" />
        </Badge>
        <Badge label="American Express" data-id="element-162" data-mp="3hbqls96rlp25">
          <span className="flex h-full w-full items-center justify-center rounded bg-[#2E77BC] text-[10px] font-black tracking-tight text-white" data-id="element-163" data-mp="3hcrtc3okntf4">
            AMEX
          </span>
        </Badge>
        <Badge label="PayPal" data-id="element-164" data-mp="3q64xk1s36hgi">
          <span className="text-[13px] font-extrabold italic" data-id="element-165" data-mp="3q6er1zccb6qy">
            <span className="text-[#003087]" data-id="element-166" data-mp="2tm60hjn52fpp">Pay</span>
            <span className="text-[#009CDE]" data-id="element-167" data-mp="2xo110lx8wp2f">Pal</span>
          </span>
        </Badge>
        <Badge label="Google Pay" data-id="element-168" data-mp="4tsnd8l85bfv">
          <span className="text-[12px] font-semibold text-cocoa" data-id="element-169" data-mp="4sr085qxoyhs">
            <span className="text-[#4285F4]" data-id="element-170" data-mp="3w03mv0al6453">G</span> Pay
          </span>
        </Badge>
        <Badge label="Apple Pay" data-id="element-171" data-mp="3vy967y6cky6t">
          <span className="flex h-full w-full items-center justify-center rounded bg-black text-[11px] font-semibold text-white" data-id="element-172" data-mp="ejvgr9w9creq">
            Apple Pay
          </span>
        </Badge>
        <Badge label="Tarjeta de débito" data-id="element-173" data-mp="3i02mdly8gyq5">
          <span className="text-center text-[9px] font-bold uppercase leading-tight text-cocoa" data-id="element-174" data-mp="3i0uegmsmgebo">Débito</span>
        </Badge>
        <Badge label="Diners Club" data-id="element-175" data-mp="3d3c0uj3ntaxc">
          <span className="text-center text-[9px] font-bold leading-tight text-[#004A97]" data-id="element-176" data-mp="3r1ikau7v38dh">Diners Club</span>
        </Badge>
      </ul>
      <p className="text-xs text-cocoa-faint" data-id="element-177" data-mp="3mxu9m2nxnwo0">Tarjetas de crédito y débito, PayPal, billeteras digitales y más.</p>
    </div>;
}